import { render } from "./AdminCockpit.vue?vue&type=template&id=6815174c&ts=true"
import script from "./AdminCockpit.vue?vue&type=script&lang=ts"
export * from "./AdminCockpit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__